/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestConvexVirtualBalanceRewardPool extends Contract<ITestConvexVirtualBalanceRewardPool> {
  operator: Call<() => string, ITestConvexVirtualBalanceRewardPool>
  'operator()': Call<() => string, ITestConvexVirtualBalanceRewardPool>
  queueNewRewards: Send<(_rewards: BigNumberish) => void, ITestConvexVirtualBalanceRewardPool>
  'queueNewRewards(uint256)': Send<(_rewards: BigNumberish) => void, ITestConvexVirtualBalanceRewardPool>
}

let ITestConvexVirtualBalanceRewardPoolBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestConvexVirtualBalanceRewardPoolBytecode = '0x';
}

// prettier-ignore
export const ITestConvexVirtualBalanceRewardPool = contract<ITestConvexVirtualBalanceRewardPool>(ITestConvexVirtualBalanceRewardPoolBytecode)`
  function operator() view returns (address)
  function queueNewRewards(uint256 _rewards)
`;